module.exports = __webpack_public_path__ + "static/media/tooltip-close.fc63a94e.svg";